export {};

$(document)
    .on('click', '.upload-file__remove', function onChange(evt) {
        const $this = $(this);
        const $target = $this.closest('.upload-files__item');
        const $formSection = $this.closest('.form-section');
        const $inputFile = $formSection.find('.add-file__input');

        $inputFile.attr('data-is-added', 'n').val('');
        $target.addClass('animated fast zoomOut');

        setTimeout(() => $target.remove(), 300);

        evt.preventDefault();
    })
    .on('change', '.add-file__input', function onChange() {
        const Input = this;
        const $input = $(Input);
        const $formSection = $input.closest('.form-section');
        const $addFile = $input.parent();
        const putToSelector = $addFile.data('put-to');
        const $putTo = $(putToSelector);

        if ($input.attr('data-is-added') === 'y') {
            $formSection.find('.upload-file__name').text(getFileName(Input.value));
            return;
        }

        $input.attr('data-is-added', 'y');
        // const ClonedInput = Input.cloneNode();

        // ClonedInput.value = null;
        // ClonedInput.required = false;

        const template = getFileTemplate({
            name: getFileName(Input.value),
        });

        const $template = $(template);

        $input.addClass('hidden-accessible');

        $template
            .addClass('animated fast pulse')
            // .prepend(Input)
            .on('click', '.upload-file__remove', onClickUploadedRemove);

        // $addFile.prepend(ClonedInput);

        $putTo.append($template);

        function onClickUploadedRemove() {
            const $button = $(this);
            const $item = $button.closest('.upload-files__item');
            const $siblings = $item.siblings();
            const siblingsAmount = $siblings.length;

            // if (siblingsAmount < 1) {
            //     ClonedInput.required = true;
            // }
        }
    });

function getFileTemplate({ name }) {
    return `<li class="upload-files__item">
                <div class="upload-file">
                    <div class="upload-file__name">${name}</div>
                    <button class="upload-file__remove">
                        <svg height="14" width="14" class="svg-symbol svg-symbol--x">
                            <use xlink:href="#svg-symbol--x"/>
                        </svg>
                    </button>
                </div>
            </li>`;
}

function getFileName(fullPath) {
    /* eslint-disable */
    const startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
    let filename = fullPath.substring(startIndex);
    if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
        filename = filename.substring(1);
    }

    return filename;
}



// WEBPACK FOOTER //
// ./js/main/module/add-file.js